import { render, staticRenderFns } from "./DeviceVirtualList.vue?vue&type=template&id=20d9781e&scoped=true"
import script from "./DeviceVirtualList.vue?vue&type=script&lang=ts"
export * from "./DeviceVirtualList.vue?vue&type=script&lang=ts"
import style0 from "./DeviceVirtualList.vue?vue&type=style&index=0&id=20d9781e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d9781e",
  null
  
)

export default component.exports